module.exports = __webpack_public_path__ + "img/isaac-pro.481ef92a.jpg";